import { ParentUsersUIProvider } from "./ParentUsersUIContext";
import { ParentUsersCard } from "./ParentUsersCard";

export function ParentUsersPage({
  history,
  userGroupId,
  userType
}) {
  return (
    <ParentUsersUIProvider>
      <ParentUsersCard
        history={history}
        userGroupId={userGroupId}
        userType={userType}
      />
    </ParentUsersUIProvider>
 );
}